import { connect } from 'react-redux';
import { compose } from 'redux';
import { getQueryString } from '../../selectors/path';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState } from '../../types/redux';
import { withApplicationContext } from '../../utils/applicationContext';
import { INewbuildingMVKProps, NewbuildingMVK } from './newbuilding_mvk';

type TNewbuildingMVKStateProps = Pick<INewbuildingMVKProps, 'MVKData' | 'mapApiKey' | 'queryString' | 'subdomain'>;
type TNewbuildingMVKContextProps = Pick<INewbuildingMVKProps, 'httpApi' | 'logger'>;

export function mapStateToProps(state: IApplicationState): TNewbuildingMVKStateProps {
  return {
    MVKData: state.newbuildingMVK,
    queryString: getQueryString(state),
    subdomain: state.subdomain,
    mapApiKey: state.common.mapApiKey,
  };
}

export function mapContextToProps({ httpApi, logger }: IApplicationContext): TNewbuildingMVKContextProps {
  return {
    httpApi,
    logger,
  };
}

export const NewbuildingMVKContainer = compose(
  withApplicationContext(mapContextToProps),
  connect(mapStateToProps),
)(NewbuildingMVK);
